import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import pt from "./components/locales/pt.json";
import en from "./components/locales/en.json";
import es from "./components/locales/es.json";

i18n.use(initReactI18next).init({
  resources: { pt: { translation: pt }, en: { translation: en }, es: { translation: es } },
  lng: "pt",
  fallbackLng: "pt",
  interpolation: { escapeValue: false }
});

export default i18n;